<template>
  <div class="home-swipe-box">
    <div class="home-swip-tabs-box">
      <ul class="home-swip-tabs">
        <li class="tab checked">捡漏宝贝</li>
      </ul>
      <div class="tomore-btn" @click="$router.push({ name: 'discounted' }, () => {})">
        <div class="text">更多</div>
        <div class="icon">
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
    <div style="margin: 10px 0;">
      <VueSlickCarousel
        v-bind="slideOptions"
        v-if="proData && proData.length > 0"
      >
        <div
          v-for="(item, index) in proData"
          :key="index"
          class="home-swip-item"
          @click="toBB(item)"
        >
          <div class="pro-swipe-item">
            <img :src="item.img" />
            <p>立赚 {{ item.money }} 元</p>
          </div>
        </div>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  name: 'HomeSwipeDataView',
  components: {
    VueSlickCarousel
  },
  data () {
    return {
      slideOptions: {
        dots: false,
        arrows: false,
        focusOnSelect: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true
      },
      proData: [
        { img: 'https://img01.yzcdn.cn/vant/cat.jpeg', money: 10 },
        { img: 'https://img01.yzcdn.cn/vant/cat.jpeg', money: 11 },
        { img: 'https://img01.yzcdn.cn/vant/cat.jpeg', money: 12 },
        { img: 'https://img01.yzcdn.cn/vant/cat.jpeg', money: 13 },
        { img: 'https://img01.yzcdn.cn/vant/cat.jpeg', money: 14 },
        { img: 'https://img01.yzcdn.cn/vant/cat.jpeg', money: 15 },
        { img: 'https://img01.yzcdn.cn/vant/cat.jpeg', money: 16 },
        { img: 'https://img01.yzcdn.cn/vant/cat.jpeg', money: 17 }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.home-swipe-box {
  background: #cc5f62;
  border-radius: 12px;
  padding: 15px;
  margin: 10px 10px 0px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  color: #e6cdb7;
  .home-swip-tabs-box {
    position: relative;
    .home-swip-tabs {
      margin: 0px;
      .tab {
        padding: 2px 8px;
        height: 20px;
        line-height: 20px;
      }
     
      .checked {
        font-size: 17px;
        font-weight: 500;
        color: #fff;
      }
    }
    .tomore-btn {
      position: absolute;
      right: 0px;
      background: #cfc9ac;
      padding: 2px 8px;
      border-radius: 10px;
      top: 1px;
      color: #87523c;
      font-size: 12px;
      height: 20px;
      line-height: 20px;
      display: flex;
      gap: 5px;
      .text {
        margin: 0 0 0 3px;
        height: 20px;
        line-height: 22px;
      }
      .icon {
        border-radius: 9px;
        width: 18px;
        height: 18px;
        text-align: center;
        line-height: 19px;
        background: #87523c;
        color: #fff;
        margin-top: 2px;
      }
    }
  }
}
.home-swip-item {
    text-align: center;
    .pro-swipe-item {
        margin: 0px 5px;
        padding: 5px;
        background: #fff;
        img {
            width: 100%;
            height: 140px;
            object-fit: cover;
        }
        p {
            background: #c84b4b;
            text-align: center;
            color: #fff;
            border-radius: 10px;
            margin-top: 8px;
        }
    }
}
</style>
